import LayoutAuthenticated from './LayoutAuthenticated.vue';
import LayoutDefault from './LayoutDefault.vue';

export default {
  LayoutAuthenticated,
  LayoutDefault,
};
